import { TextField } from '@material-ui/core'
import styled from 'styled-components'
import { truncateStyles } from 'components/common/styles'
import {
  MAIN_BACKGROUND,
  SECONDARY_TEXT,
  SUMMER_SKY,
  SUMMER_SKY_RGB,
  WHITE,
  PRIMARY,
  DIVIDER_COLOR,
} from 'constants/colors'

export const StyledSelectInputOption = styled.div<{
  checked?: boolean
  nowrap?: boolean
  width?: string
}>`
  border: 1px solid;
  border-color: ${({ checked }) => (checked ? SUMMER_SKY : MAIN_BACKGROUND)};
  border-radius: 8px;
  padding: 16px;
  background: ${({ checked }) =>
    checked ? `rgba(${SUMMER_SKY_RGB}, .08)` : WHITE};
  width: ${({ width }) => width || 'auto'};
  white-space: ${({ nowrap }) => (nowrap ? 'nowrap' : 'auto')};
  color: ${SECONDARY_TEXT};
  cursor: pointer;

  .MuiCheckbox-root,
  .MuiRadio-root {
    padding: 0;
    margin-right: 8px;
    transform: translateY(-2px);

    &.Mui-checked {
      color: ${PRIMARY} !important;
    }
  }
`

const GeneralListView = styled.div<{ disabled?: boolean }>`
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  opacity: ${({ disabled }) => (disabled ? '.8' : '1')};
  margin-top: 8px;
`

export const StyledListView = styled(GeneralListView)<{
  isMatrixView?: boolean
}>`
  display: ${({ isMatrixView }) => (isMatrixView ? 'flex' : 'block')};

  ${StyledSelectInputOption} {
    flex: 1;
    text-align: ${({ isMatrixView }) => (isMatrixView ? 'center' : 'left')};
    ${({ isMatrixView }) =>
      isMatrixView
        ? {
            borderRadius: 0,
          }
        : {
            margin: '0 0 8px',
          }}

    &:first-child {
      border-radius: ${({ isMatrixView }) => isMatrixView && '8px 0 0 8px'};
    }

    &:last-child {
      border-radius: ${({ isMatrixView }) => isMatrixView && '0 8px 8px 0'};
    }
  }
`

export const StyledHorizontalScrollView = styled(GeneralListView)`
  overflow-x: auto;
  display: grid;
  grid-gap: 8px;
  grid-auto-flow: column;
  grid-template: repeat(5, auto) / repeat(1, 1fr);
`

export const StyledTextArea = styled(TextField)`
  .MuiInputLabel-root {
    top: 16px;
    left: 16px;
  }

  .MuiInputBase-root {
    padding: 0;
    border: 1px solid ${DIVIDER_COLOR};
    border-radius: 8px;

    &:before,
    &:after {
      display: none;
    }
  }

  textarea {
    padding: 16px;
    min-height: 81px;
  }
`

export const Hint = styled.div`
  ${truncateStyles};
`

export const SelectContainer = styled.div`
  margin-top: 16px;
`
